import { Map, Globe, Layers, Compass, MapPin, Mountain, Waves, TreePine, Satellite, Radar, Flag, Star } from 'lucide-vue-next'
import type { Component } from 'vue'

// Named icons available when creating/editing a Map. Stored as a string on the
// mock map model (`icon`) and resolved to a component via mapIcon().
export const MAP_ICONS: Record<string, Component> = {
  Map, Globe, Layers, Compass, MapPin, Mountain, Waves, TreePine, Satellite, Radar, Flag, Star
}

export const MAP_ICON_NAMES = Object.keys(MAP_ICONS)

export const mapIcon = (name?: string): Component => MAP_ICONS[name || 'Map'] || Map

// Swatch palette offered in the create/edit dialog.
export const MAP_COLORS = [
  '#2563EB', '#7C3AED', '#DB2777', '#DC2626', '#EA580C',
  '#CA8A04', '#16A34A', '#0891B2', '#475569', '#0F172A'
]
